<template>
  <div
    v-if="!finishedLoaded"
    class="d-flex justify-center align-center"
    style="height: 50vh"
  >
    <v-progress-circular
      indeterminate
      color="primary"
      size="64"
    ></v-progress-circular>
  </div>
  <div v-else>
    <!-- Description -->
    <v-row class="ma-1">
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-text-field
              v-model="shootingProgramTemplate.name.value"
              label="Name"
              placeholder="Shooting program template"
              :rules="textRules"
            ></v-text-field>

            <v-autocomplete
              :items="getLanguages()"
              label="Language"
              :placeholder="
                getLanguage(shootingProgramTemplate.defaultValues.language)
              "
              @input="setLanguage"
              required
            ></v-autocomplete>

            <v-select
              :items="getExecutionMode()"
              v-model="shootingProgramTemplate.executionMode"
              label="Exectution mode"
              style="width: 20%"
            ></v-select>

            <v-text-field
              v-model.number="shootingProgramTemplate.requiredTargetCount"
              type="number"
              min="1"
              label="Required target count (optional)"
            />

            <v-divider style="margin-bottom: 20px"></v-divider>

            <!-- MEDIA  -->
            <span>Media</span>
            <v-select
              v-if="!isSimpleExecutionMode"
              :items="mediaCollectionOptions"
              item-text="name"
              item-value="id"
              v-model="mediaCollectionId"
              label="Media collection"
            />

            <div v-if="mediaCollectionId !== null">
              <v-select
                :items="mediaProfiles"
                item-text="name"
                item-value="id"
                v-model="defaultMediaProfileId"
                label="Default media profile"
              />

              <v-select
                :items="mediaTemplateOptions"
                item-value="id"
                item-text="name"
                v-model="selectedManualStopMediaTemplateId"
                label="Manual stop media"
              />

              <v-btn class="mb-5 mt-2" @click="showCalloutsDialog()"
                >Apply callouts</v-btn
              >
            </div>

            <v-dialog v-model="addCalloutsDialog.visible" max-width="500px">
              <v-card class="pa-4">
                Organization:
                <v-select
                  v-model="addCalloutsDialog.type"
                  :items="addCalloutsDialog.availableTypes"
                ></v-select>
                Media mapping:
                <div>
                  <!-- Mapping: Klar kommer om... -->
                  <v-select
                    v-model="addCalloutsDialog.calloutMapping.start"
                    :items="mediaTemplates"
                    item-text="name"
                    item-value="id"
                    label="Klar kommer..."
                  ></v-select>
                  <!-- Mapping: Klar  -->
                  <v-select
                    v-model="addCalloutsDialog.calloutMapping.klar"
                    :items="mediaTemplates"
                    item-text="name"
                    item-value="id"
                    label="Klar"
                  ></v-select>
                  <!-- Mapping: Ild ... -->
                  <v-select
                    v-model="addCalloutsDialog.calloutMapping.ild"
                    :items="mediaTemplates"
                    item-text="name"
                    item-value="id"
                    label="Ild"
                  ></v-select>
                  <!-- Mapping: Stans ... -->
                  <v-select
                    v-model="addCalloutsDialog.calloutMapping.stans"
                    :items="mediaTemplates"
                    item-text="name"
                    item-value="id"
                    label="Stans"
                  ></v-select>
                </div>
                <v-card-actions>
                  <v-spacer />
                  <v-btn text @click="closeCalloutsDialog()">Cancel</v-btn>
                  <v-btn
                    color="primary"
                    :loading="addCalloutsDialog.loading"
                    @click="applyCallouts(addCalloutsDialog.type)"
                    >Apply</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-divider style="margin-bottom: 20px"></v-divider>

            <div class="d-flex flex-row">
              <v-checkbox
                v-if="!isSimpleExecutionMode"
                v-model="shootingProgramTemplate.preApprove"
                label="Enable pre approve"
                class="mr-5"
              />
              <v-checkbox
                v-if="!isSimpleExecutionMode"
                v-model="shootingProgramTemplate.enableTeamShooting"
                label="Enable team shooting"
              />
            </div>

            <v-text-field
              v-if="shootingProgramTemplate.enableTeamShooting"
              v-model.number="
                shootingProgramTemplate.nominalNumberOfTeamMembers
              "
              type="number"
              min="1"
              label="Nominal number of team members"
            />

            <v-divider style="margin-bottom: 20px"></v-divider>

            <!-- Execution groups -->
            <div class="d-flex align-center mb-2">
              <span>Execution groups</span>
              <v-btn icon small class="ml-2" @click="addExecutionGroup()">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>

            <v-row
              v-for="(group, index) in shootingProgramTemplate.executionGroups"
              :key="group.id"
              class="align-center"
            >
              <v-col cols="4">
                <v-text-field v-model="group.name" label="Name" />
              </v-col>
              <v-col cols="6">
                <v-select
                  :items="seriesOptions"
                  item-text="name"
                  item-value="id"
                  v-model="group.series"
                  label="Series"
                  multiple
                  chips
                  deletable-chips
                />
              </v-col>
              <v-col cols="2">
                <v-btn icon @click="onDeleteExecutionGroup(index)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-tabs v-model="tab" align-with-title>
          <v-tabs-slider color="blue"></v-tabs-slider>

          <v-tab v-for="groupItem in groupItems" :key="groupItem">
            {{ groupItem }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item
            v-for="(groupItem, groupIndex) in groupItems"
            :key="groupIndex"
            class="ma-4"
          >
            <!-- Series -->
            <v-row v-if="groupIndex == 0">
              <EditSeriesPanel
                :series="shootingProgramTemplate.series"
                :sums="shootingProgramTemplate.sums"
                :sumSequences="shootingProgramTemplate.sumSequences"
                v-on:onDeleteSeries="onDeleteSeries($event)"
                v-on:onCopySeries="onCopySeries($event)"
                v-on:onDragSeriesEnd="onDragSeriesEnd($event)"
                :profiles="shootingProgramTemplate.profiles"
                :scoringDefinitions="scoringDefinitions"
                :calloutConfig="shootingProgramTemplate.calloutConfig"
                :selectedAudioCollection="selectedAudioCollection"
                :selectedAudioProfileId="audioProfileId"
                :mediaTemplates="mediaTemplateOptions"
                :teamShootingEnabled="
                  shootingProgramTemplate.enableTeamShooting
                "
                :requiredTargetCount="
                  shootingProgramTemplate.requiredTargetCount
                    ? shootingProgramTemplate.requiredTargetCount
                    : null
                "
                ref="SeriesPanel"
              />
            </v-row>

            <!-- Sums -->
            <v-row v-if="groupIndex == 1">
              <EditSumsPanel
                :series="shootingProgramTemplate.series"
                :sums="shootingProgramTemplate.sums"
                :sumSequences="shootingProgramTemplate.sumSequences"
                :profiles="shootingProgramTemplate.profiles"
                v-on:onDeleteSum="onDeleteSum($event)"
                v-on:onDeleteSumSequence="onDeleteSumSequence($event)"
                v-on:onDragSumEnd="onDragSumEnd($event)"
                v-on:onDragSequenceEnd="onDragSequenceEnd($event)"
                v-on:onToFromShot="onToFromShot($event)"
              />
            </v-row>

            <!-- Selections -->
            <v-row v-if="groupIndex == 2">
              <EditSelectionsPanel
                :selectionEntry="shootingProgramTemplate.selectionEntry"
                v-on:onDeleteSelectionEventTemplate="
                  onDeleteSelectionEventTemplate($event)
                "
                v-on:onDeleteSelectionCategory="
                  onDeleteSelectionCategory($event)
                "
              />
            </v-row>

            <!-- Tags -->
            <v-row v-if="groupIndex == 3">
              <EditTagsPanel
                :tagGroups="shootingProgramTemplate.tagGroups"
                v-on:onDeleteTagGroup="onDeleteTagGroup($event)"
              />
            </v-row>

            <!-- Profile -->
            <v-row v-if="groupIndex == 4">
              <p></p>
              <EditProfilePanel
                :defaultProfileName="shootingProgramTemplate.defaultProfileName"
                :profiles="shootingProgramTemplate.profiles"
                v-on:onDeleteProfile="onDeleteProfile($event)"
                v-on:onDragProfileEnd="onDragProfileEnd($event)"
                v-on:onDeleteProfileCategory="onDeleteProfileCategory($event)"
              />
            </v-row>
          </v-tab-item>
          <v-alert dense border="left" type="error" v-if="this.error == true">
            <div class="col-md-6 col-md-6 col-lg-10 d-none d-md-block">
              <ul style="color: white">
                <li v-for="(error, index) in errorList" :key="index">
                  {{ error }}
                </li>
              </ul>
            </div>
          </v-alert>
        </v-tabs-items>
        <div class="row my-2">
          <div class="ml-8">
            <v-btn @click="saveShootingTemplate()" id="buttonSave">
              <v-progress-circular
                indeterminate
                v-if="this.isLoading"
              ></v-progress-circular>
              <div v-if="this.isSaved">saved<v-icon>mdi-check</v-icon></div>
              <div v-else>Save Template</div>
            </v-btn>
          </div>
          <div class="ml-6">
            <v-btn color="primary" @click="ExitTemplate()">
              Exit Template
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    <c-confirmation-dialog ref="confirmationDialog"></c-confirmation-dialog>
  </div>
</template>

<script>
import * as helpers from './shootingProgramHelpers.js';
import { v4 as uuidv4 } from 'uuid';
import EditSeriesPanel from './Edit/EditSeriesPanel';
import EditSumsPanel from './Edit/EditSumsPanel';
import EditSelectionsPanel from './Edit/EditSelectionsPanel';
import EditTagsPanel from './Edit/EditTagsPanel';
import EditProfilePanel from './Edit/EditProfilePanel';
import {
  GET_SHOOTING_PROGRAM_TEMPLATE_QUERY,
  ADD_OR_UPDATE_SHOOTING_PROGRAM_TEMPLATE,
  GET_AUDIO_COLLECTION_FULL_QUERY,
  GET_MEDIA_COLLECTION_QUERY,
  GET_MEDIA_FILES_QUERY,
} from '../../graphql/shootingProgramQueries.js';
import { GET_TARGET_SCORING_DEFINITION_QUERY } from '../../graphql/targetScoringDefinitionQueries.js';
import _ from 'lodash';
// import { GET_AUDIO_COLLECTION_QUERY } from '../../graphql/shootingProgramQueries.js';

export default {
  name: 'EditShootingProgramTemplate',
  components: {
    EditSeriesPanel,
    EditSumsPanel,
    EditSelectionsPanel,
    EditTagsPanel,
    EditProfilePanel,
    CConfirmationDialog: () => import('../common/CConfirmationDialog'),
  },

  apollo: {
    $client: 'shootingProgramClient',
    getAudioCollections: {
      query: GET_AUDIO_COLLECTION_FULL_QUERY,
      loadingKey: 'loading',
    },
    getMediaCollections: {
      query: GET_MEDIA_COLLECTION_QUERY,
      loadingKey: 'loading',
      options: { fetchPolicy: 'cache-and-network' },
    },
    getMediaFiles: {
      query: GET_MEDIA_FILES_QUERY,
      client: 'shootingProgramClient',
      loadingKey: 'loading',
      options: { fetchPolicy: 'cache-and-network' },
    },
  },

  created() {
    this.populateData();
  },

  data: () => ({
    selectedAudioCollection: null,
    selectedAudioProfile: null,
    mediaCollectionId: null,
    defaultMediaProfileId: null,
    selectedManualStopMediaTemplateId: null,
    enablePreApprove: false,
    drag: false,
    tab: null,
    finishedLoaded: false,
    textRules: [(v) => v.length > 0 || 'Textfield must not be empty'],
    groupItems: ['Series', 'Sums', 'Selections', 'Tags', 'Profiles'],
    name: 'DFS 25 skudd',
    language: 'nb',
    audioCollection: null,
    audioTemplates: null,
    error: false,
    errorList: [],
    isLoading: false,
    isSaved: true,
    scoringDefinitions: {},
    toFromShotList: [],
    shootingProgramTemplate: {},
    addCalloutsDialog: {
      visible: false,
      loading: false,
      type: 'DFS',
      availableTypes: ['DFS'],
      calloutMapping: {
        start: '0cc92a4e-82c2-4f6e-b984-4d7fb652e87c',
        klar: 'bc5a4b0f-4431-434f-8c48-f1566c2f3749',
        ild: '58a30930-8468-41b0-a8a5-1cb151bf138f',
        stans: '98923e12-ef55-4699-bf7f-ef46f097b07e',
      },
    },
  }),

  watch: {
    shootingProgramTemplate: {
      deep: true,
      handler() {
        if (this.isSaved && document.getElementById('buttonSave') != null) {
          this.isSaved = false;
          document.getElementById('buttonSave').style.backgroundColor =
            '#01579B';
          document.getElementById('buttonSave').style.color = 'white';
        }
      },
    },
    selectedAudioCollection: {
      handler() {
        if (!this.selectedAudioCollection || !this.selectedAudioCollection.id) {
          this.selectedAudioProfile = null;
        } else
          this.selectedAudioProfile =
            this.selectedAudioCollection.jsonData.audioCollection.audioProfiles[0];
      },
    },
  },
  computed: {
    selectedMediaFiles() {
      const mediaProfile = this.mediaProfiles.find(
        (profile) => profile.id === this.defaultMediaProfileId,
      );
      if (this.getMediaFiles && mediaProfile) {
        return this.getMediaFiles.filter((file) =>
          mediaProfile.media.find((media) => media.mediaFileId === file.id),
        );
      }
      return [];
    },
    audioCollectionOptions() {
      return [
        {
          id: null,
          jsonData: { audioCollection: { name: 'No collection' } },
        },
      ].concat(this.getAudioCollections);
    },
    mediaCollectionOptions() {
      return [
        {
          id: null,
          name: 'No collection',
        },
      ].concat(this.getMediaCollections);
    },
    audioProfiles() {
      if (!this.selectedAudioCollection || !this.selectedAudioCollection.id)
        return [];

      const audioProfile =
        this.selectedAudioCollection.jsonData.audioCollection.audioProfiles;
      return audioProfile ? audioProfile : [];
    },
    mediaProfileOptions() {
      return [
        {
          id: null,
          name: 'No media template',
        },
      ].concat(this.mediaProfiles);
    },
    mediaTemplateOptions() {
      return [
        {
          id: null,
          name: 'No media template',
        },
      ].concat(this.mediaTemplates);
    },
    mediaTemplates() {
      if (!this.mediaCollectionId) return [];

      const mediaTemplate = this.getMediaCollections.find(
        (collection) => collection.id === this.mediaCollectionId,
      )?.mediaTemplates;
      return mediaTemplate ? mediaTemplate : [];
    },
    mediaProfiles() {
      if (!this.mediaCollectionId) return [];

      const mediaProfile = this.getMediaCollections.find(
        (collection) => collection.id === this.mediaCollectionId,
      )?.mediaProfiles;
      return mediaProfile ? mediaProfile : [];
    },
    audioProfileId() {
      return this.selectedAudioProfile ? this.selectedAudioProfile.id : null;
    },
    isSimpleExecutionMode() {
      return (
        this.shootingProgramTemplate.executionMode.toUpperCase() === 'SIMPLE'
      );
    },
    seriesOptions() {
      return this.shootingProgramTemplate.series.map((serie) => ({
        id: serie.id,
        name: serie.name?.defaultValue?.value,
      }));
    },
  },

  methods: {
    showCalloutsDialog() {
      this.addCalloutsDialog.visible = true;
    },
    closeCalloutsDialog() {
      this.addCalloutsDialog.visible = false;
    },
    calloutsConfigured(series) {
      return series.procedures.some((p) =>
        p.procedureSteps.some((s) => s.callouts && s.callouts.length > 0),
      );
    },
    addPreparationStep(steps) {
      const data = {
        callouts: [
          {
            audioTemplateId: {
              defaultValue: '',
            },
            execution: {
              waitUntilFinished: true,
            },
            media: [
              {
                client: ['E_MONITOR', 'E_CONTROL'],
                mediaData: null,
                mediaFormat: 'MP3',
                mediaTemplateId: {
                  defaultValue: this.addCalloutsDialog.calloutMapping.start,
                },
                mediaType: 'AUDIO',
              },
            ],
          },
        ],
        time: {
          from: {
            defaultValue: {
              languages: [],
              value: '',
            },
            profileValues: [],
          },
          mode: 'PREPARATION_TIME',
        },
        scoringStateControl: [],
        id: uuidv4(),
        start: 'WAIT_USER_INPUT',
      };

      steps.unshift(data);
    },
    addCalloutToCountdown(countdownStep) {
      countdownStep.callouts = [
        {
          audioTemplateId: {
            defaultValue: '',
            profileValues: null,
          },
          execution: {
            executionTimingMode: 'START_AT_TIME',
            mode: 'FROM_BEGIN',
            time: {
              defaultValue: {
                value: '10',
              },
              profileValues: [],
            },
            waitUntilFinished: false,
          },
          media: [
            {
              client: ['E_MONITOR', 'E_CONTROL'],
              mediaData: {
                defaultValue: '',
              },
              mediaFormat: 'MP3',
              mediaTemplateId: {
                defaultValue: this.addCalloutsDialog.calloutMapping.klar,
              },
              mediaType: 'AUDIO',
            },
          ],
        },
      ];
    },
    addCalloutsToScoring(scoringStep) {
      scoringStep.callouts = [
        {
          audioTemplateId: {
            defaultValue: '',
            profileValues: null,
          },
          execution: {
            executionTimingMode: 'START_AT_TIME',
            mode: 'FROM_BEGIN',
            time: {
              defaultValue: {
                value: '00:00',
              },
              profileValues: [],
            },
            waitUntilFinished: false,
          },
          media: [
            {
              client: ['E_MONITOR', 'E_CONTROL'],
              mediaData: {
                defaultValue: '',
              },
              mediaFormat: 'MP3',
              mediaTemplateId: {
                defaultValue: this.addCalloutsDialog.calloutMapping.ild,
              },
              mediaType: 'AUDIO',
            },
          ],
        },
        {
          audioTemplateId: {
            defaultValue: '',
            profileValues: null,
          },
          execution: {
            executionTimingMode: 'FINISH_AT_TIME',
            mode: 'FROM_END',
            time: {
              defaultValue: {
                value: '00:00',
              },
              profileValues: [],
            },
            waitUntilFinished: false,
          },
          media: [
            {
              client: ['E_MONITOR', 'E_CONTROL'],
              mediaData: {
                defaultValue: '',
              },
              mediaFormat: 'MP3',
              mediaTemplateId: {
                defaultValue: this.addCalloutsDialog.calloutMapping.stans,
              },
              mediaType: 'AUDIO',
            },
          ],
        },
      ];
    },
    applyCallouts(type) {
      this.addCalloutsDialog.loading = true;
      switch (type) {
        case 'DFS':
          {
            // Verify which series has the correct structure to support automatically
            // applying the callout config
            for (const series of this.shootingProgramTemplate.series.filter(
              (s) => !this.calloutsConfigured(s),
            )) {
              const procedure = series.procedures[0];
              if (procedure) {
                // #1 Add a procedure step for preparation time with the start command
                if (procedure.procedureSteps.length === 2) {
                  this.addPreparationStep(procedure.procedureSteps);
                }

                // #2 Add the "Klar" command after 10 seconds of the countdown period
                const countdown = procedure.procedureSteps.find(
                  (s) => s.time.mode === 'COUNTDOWN_TIME',
                );
                if (countdown) {
                  this.addCalloutToCountdown(countdown);
                }

                // #3 Add the "Ild" and "Stans" commands to the scoring period
                const scoring = procedure.procedureSteps.find(
                  (s) => s.time.mode === 'SCORING_TIME',
                );
                if (scoring) {
                  this.addCalloutsToScoring(scoring);
                }
              } else {
                // No procedures were found.
                // @todo Give feedback to user.
              }
            }
          }
          break;
      }

      this.addCalloutsDialog.loading = false;
      this.closeCalloutsDialog();
    },
    isNoTime(time) {
      const timeCheck = time.to ? time.to : time.from;
      return (
        !time ||
        !timeCheck ||
        !timeCheck.defaultValue ||
        !timeCheck.defaultValue.value ||
        timeCheck.defaultValue.value === '0' ||
        timeCheck.defaultValue.value === '00'
      );
    },
    audioProfile() {
      if (
        this.selectedAudioCollection === null ||
        this.selectedAudioCollection.id === null ||
        !this.shootingProgramTemplate.calloutConfig
      )
        return null;

      return this.selectedAudioCollection?.jsonData.audioCollection.audioProfiles.filter(
        (prof) =>
          prof.id ==
          this.shootingProgramTemplate.calloutConfig.defaultAudioProfileId,
      )[0];
    },
    async getSingleAudioCollection() {
      try {
        const audioCollection = await this.$apollo.query({
          query: GET_AUDIO_COLLECTION_FULL_QUERY,
          variables: {
            id: this.shootingProgramTemplate.calloutConfig?.audioCollectionId,
          },
        });

        const collection = audioCollection.data.getAudioCollections;
        return collection.length === 1 ? collection[0] : null;
      } catch (err) {
        console.log(err);
      }
    },
    setLanguage(value) {
      this.shootingProgramTemplate.defaultValues.language =
        helpers.getLanguageAbbreviation(value);
    },
    getLanguage(key) {
      return helpers.getLanguage(key);
    },

    getExecutionMode() {
      return helpers.getExecutionMode();
    },

    getLanguages() {
      return helpers.getLanguages();
    },
    getLanguageAbbreviation(targetLanguage) {
      return helpers.getLanguageAbbreviation(targetLanguage);
    },
    onDeleteSeries(id) {
      //Checking if the serie to be deleted also is registrered in sums and sumSequence and then deleting if it's true.
      for (let i = 0; i < this.shootingProgramTemplate.sums.length; i++) {
        if (this.shootingProgramTemplate.sums[i].series.length != 0) {
          if (this.shootingProgramTemplate.sums[i].series[0].id == null) {
            this.shootingProgramTemplate.sums[i].series =
              this.shootingProgramTemplate.sums[i].series.filter(
                (serie) => serie !== id,
              );
          } else {
            this.shootingProgramTemplate.sums[i].series =
              this.shootingProgramTemplate.sums[i].series.filter(
                (serie) => serie.id !== id,
              );
          }
        }
      }

      this.shootingProgramTemplate.series =
        this.shootingProgramTemplate.series.filter((serie) => serie.id !== id);

      // Remove the deleted series from any execution groups referencing it.
      this.shootingProgramTemplate.executionGroups.forEach((group) => {
        group.series = group.series.filter((serieId) => serieId !== id);
      });
    },
    addExecutionGroup() {
      this.shootingProgramTemplate.executionGroups.push({
        id: uuidv4(),
        name: '',
        series: [],
      });
    },
    onDeleteExecutionGroup(index) {
      this.shootingProgramTemplate.executionGroups.splice(index, 1);
    },
    onCopySeries(serie) {
      let newSerie = _.cloneDeep(serie);
      newSerie.id = uuidv4();
      newSerie.name.defaultValue.value =
        serie.name.defaultValue.value + ' - copy';
      this.shootingProgramTemplate.series.push(newSerie);
    },
    onDeleteSum(id) {
      this.shootingProgramTemplate.sums =
        this.shootingProgramTemplate.sums.filter((sum) => sum.id !== id);
      //Delete sum from sumsequence if it exists there.
      for (
        let i = 0;
        i < this.shootingProgramTemplate.sumSequences.length;
        i++
      ) {
        this.shootingProgramTemplate.sumSequences[i].sumIds =
          this.shootingProgramTemplate.sumSequences[i].sumIds.filter(
            (sumID) => sumID !== id,
          );
      }
    },
    onDeleteSumSequence(id) {
      this.shootingProgramTemplate.sumSequences =
        this.shootingProgramTemplate.sumSequences.filter(
          (sumSequence) => sumSequence.id !== id,
        );
    },
    onDragSumEnd(sumList) {
      this.shootingProgramTemplate.sums = sumList;
    },
    onToFromShot(toFromList) {
      if (this.toFromShotList == toFromList)
        if (this.isSaved && document.getElementById('buttonSave') != null) {
          this.isSaved = false;
          document.getElementById('buttonSave').style.backgroundColor =
            '#01579B';
          document.getElementById('buttonSave').style.color = 'white';
        }

      this.toFromShotList = toFromList;
    },
    onDragSequenceEnd(sequenceList) {
      this.shootingProgramTemplate.sumSequences = sequenceList;
    },
    onDragSeriesEnd(seriesList) {
      this.shootingProgramTemplate.series = seriesList;
    },
    onDragProfileEnd(profileList) {
      this.shootingProgramTemplate.profiles = profileList;
    },
    onDeleteTagGroup(index) {
      this.shootingProgramTemplate.tagGroups.splice(index, 1);
    },
    onDeleteSelectionEventTemplate(index) {
      this.shootingProgramTemplate.selectionEntry.eventTemplates.splice(
        index,
        1,
      );
    },
    onDeleteSelectionCategory(index) {
      this.shootingProgramTemplate.selectionEntry.categories.splice(index, 1);
    },

    onDeleteProfile(id) {
      this.shootingProgramTemplate.profiles =
        this.shootingProgramTemplate.profiles.filter(
          (profile) => profile.id !== id,
        );

      //Checking if the profile to be deleted is registrered in series and seriesTime, and then deleting it if it's true
      for (let i = 0; i < this.shootingProgramTemplate.series.length; i++) {
        this.shootingProgramTemplate.series[i].name.profileValues =
          this.filterID(
            id,
            this.shootingProgramTemplate.series[i].name.profileValues,
          );

        for (let procedure of this.shootingProgramTemplate.series[i]
          .procedures) {
          for (let procedureStep of procedure.procedureSteps) {
            if (!procedureStep.time) continue;

            procedureStep.time.from.profileValues = this.filterID(
              id,
              procedureStep.time.from.profileValues,
            );
          }
        }
      }
    },

    //Filter array on id
    filterID(id, filterArray) {
      for (let j = 0; j < filterArray.length; j++) {
        if (filterArray[j].id == id) {
          filterArray[j].id = '';
        }
      }

      return filterArray;
    },

    onDeleteProfileCategory(profileIndexes) {
      this.shootingProgramTemplate.profiles[
        profileIndexes.profileLocation
      ].categories.splice(profileIndexes.categoryLocation, 1);
    },

    //Save the template when user clicks save.
    async saveShootingTemplate() {
      this.isLoading = true;
      this.error = false;
      this.errorList = [];
      const templateStorage = JSON.parse(
        JSON.stringify(this.shootingProgramTemplate),
      );
      let numberOfSerieShots = 0;

      //Makes sure sums.series is formatted correctly in accordance with graphql
      for (let j = 0; j < templateStorage.sums.length; j++) {
        let newSumTab = [];

        //Check if No series has been choosen for subtotal
        if (
          templateStorage.sums[j].series.length == 0 &&
          templateStorage.sums[j].type == 'SUB_SERIES_TOTAL'
        ) {
          this.setTemplateError(
            'Sum',
            'No subtype series has been choosen for "' +
              templateStorage.sums[j].name.defaultValue.value +
              '" ',
          );
          this.isLoading = false;
          return;
        }

        for (let i = 0; i < templateStorage.sums[j].series.length; i++) {
          //Validate and Add sub_series_total into the shooting program with correct format
          if (templateStorage.sums[j].type == 'SUB_SERIES_TOTAL') {
            let shotList = this.toFromShotList[j];

            if (shotList != undefined) {
              templateStorage.series.forEach((serie) => {
                //Checking number of shots in serie
                if (templateStorage.sums[j].series[i].id != undefined) {
                  if (serie.id == templateStorage.sums[j].series[i].id) {
                    numberOfSerieShots = serie.shots.count;
                  }
                } else {
                  if (serie.id == templateStorage.sums[j].series[i]) {
                    numberOfSerieShots = serie.shots.count;
                  }
                }
              });

              //Check for null values
              if (shotList.from == null) {
                this.setTemplateError(
                  'Sum',
                  'Subtotals from and to shot at "' +
                    templateStorage.sums[j].name.defaultValue.value +
                    '" has not been set.',
                );
                this.isLoading = false;
                return;
              }

              //Check for null values
              if (shotList.to == null) {
                this.setTemplateError(
                  'Sum',
                  'Subtotals from and to shot at "' +
                    templateStorage.sums[j].name.defaultValue.value +
                    '" has not been set.',
                );
                this.isLoading = false;
                return;
              }

              if (shotList.to > numberOfSerieShots) {
                this.setTemplateError(
                  'Sum',
                  'Number of shots set in subtotalsum: "' +
                    templateStorage.sums[j].name.defaultValue.value +
                    '" exceeds the number of shots registrered in serie.',
                );
                this.isLoading = false;
                return;
              }

              let finalShotList = { from: shotList.from, to: shotList.to };

              if (templateStorage.sums[j].series[i].id == undefined) {
                newSumTab[i] = {
                  id: templateStorage.sums[j].series[i],
                  shots: finalShotList,
                };
              } else
                newSumTab[i] = {
                  id: templateStorage.sums[j].series[i].id,
                  shots: finalShotList,
                };
            } else {
              //End of to and from undefined
              if (templateStorage.sums[j].series[i].shots == undefined) {
                this.setTemplateError(
                  'Sum',
                  'Subtotals from and to shot at "' +
                    templateStorage.sums[j].name.defaultValue.value +
                    '" has not been set.',
                );
                this.isLoading = false;
                return;
              }
              if (
                templateStorage.sums[j].series[i].shots.to == null &&
                templateStorage.sums[j].series[i].shots.from == null
              ) {
                this.setTemplateError(
                  'Sum',
                  'Subtotals from and to shot at "' +
                    templateStorage.sums[j].name.defaultValue.value +
                    '" has not been set.',
                );
                this.isLoading = false;
                return;
              }

              newSumTab[i] = templateStorage.sums[j].series[i]; //No change has occured
            }
          } else {
            //End of subTotal

            if (templateStorage.sums[j].series[i].id == undefined) {
              newSumTab[i] = {
                id: templateStorage.sums[j].series[i],
                shots: null,
              };
            } else {
              newSumTab[i] = templateStorage.sums[j].series[i];

              if (newSumTab[i].shots != undefined) {
                newSumTab[0].shots = null;
              }
            }
          }
        }

        //Save the index equivalent of the shotnumber
        if (this.toFromShotList.length != 0)
          for (let m = 0; m < newSumTab.length; m++) {
            if (newSumTab[m].shots != null) {
              if (newSumTab[m].shots.from != null) newSumTab[m].shots.from -= 1;

              if (newSumTab[m].shots.to != null) newSumTab[m].shots.to -= 1;
            }
          }

        templateStorage.sums[j].series = newSumTab;
      }
      //Validate timeSeries
      for (let k = 0; k < templateStorage.series.length; k++) {
        //remove procedures with no steps
        let procedureArray = templateStorage.series[k].procedures;
        templateStorage.series[k].procedures = procedureArray.filter(
          (procedure) => procedure.procedureSteps.length !== 0,
        );

        for (let procedure of templateStorage.series[k].procedures) {
          if (!procedure.type) {
            procedure.type = 'SHOOTING_STAGE';
          }

          for (let procedureStep of procedure.procedureSteps) {
            let timeCheck = procedureStep.time.from.defaultValue.value;

            if (procedureStep.time.to) {
              timeCheck = procedureStep.time.to.defaultValue.value;
            }

            // Since we use preparation time for "klar om 10 sekunder fra nå", it does not require a time.
            // If no time is set for preparation time, we also disable execution mode, time and timing mode
            const allowNoPreparationTime =
              procedureStep.time.mode === 'PREPARATION_TIME' &&
              timeCheck === '';
            if (
              !allowNoPreparationTime &&
              !helpers.validateTimeInput(timeCheck)
            ) {
              this.setTemplateError(
                'Time',
                "Invalid input in series: The time input in time is not written in the correct format. Please use the following format: 'HH:MM:SS'",
              );
              return;
            }

            for (let profileTime of procedureStep.time.from.profileValues) {
              if (!helpers.validateTimeInput(profileTime.value.value)) {
                this.setTemplateError(
                  'Time',
                  "Invalid input in series:  The time input in Time-profiles is not written in the correct format. Please use the following format: 'HH:MM:SS'",
                );
                return;
              }
            }

            const stepHasNoTime = this.isNoTime(procedureStep.time);
            if (procedureStep.callouts !== null) {
              for (let callout of procedureStep.callouts) {
                if (stepHasNoTime) {
                  delete callout.execution.mode;
                  delete callout.execution.time;
                  delete callout.execution.executionTimingMode;
                  delete callout.audioTemplateId.profileValues;
                } else if (
                  !helpers.validateTimeInput(
                    callout.execution.time.defaultValue.value,
                  )
                ) {
                  this.setTemplateError(
                    'Time',
                    "Invalid input in series's procedureStep: The time input in time is not written in the correct format. Please use the following format: 'HH:MM:SS'",
                  );
                }

                //Adapt and validate MEDIA
                if (callout.media) {
                  for (let media of callout.media) {
                    if (media.mediaTemplateId) {
                      if (media.mediaTemplateId.defaultValue) {
                        media.mediaData = null;
                        const profile = this.mediaProfiles.find(
                          (profile) =>
                            profile.id === this.defaultMediaProfileId,
                        );
                        if (!profile) {
                          this.setTemplateError(
                            'Time',
                            'Please pick a default media profile for media callouts',
                          );
                          return;
                        }
                        const mediaTemplate = profile.media.find(
                          (mediaElement) => {
                            return (
                              mediaElement.mediaTemplateId ==
                              media.mediaTemplateId.defaultValue
                            );
                          },
                        );
                        if (mediaTemplate) {
                          const file = this.getMediaFiles.find(
                            (file) => file.id === mediaTemplate.mediaFileId,
                          );
                          media.mediaFormat = file.jsonData.mediaFormat;
                          media.mediaData = null;
                          media.mediaType = file.jsonData.mediaType;
                        }
                      } else {
                        media.mediaTemplateId = null;
                      }
                    }
                  }
                  if (callout.media.length === 0) {
                    delete callout.media;
                  }
                }
              }
            } else {
              if (
                !this.selectedAudioCollection ||
                !this.selectedAudioCollection.id
              ) {
                delete procedureStep.callouts;
              }
            }

            if (stepHasNoTime) delete procedureStep.time;
          }
        }

        //Making sure targetLift contains type
        for (let targetLift of templateStorage.series[k].targetLiftPosition) {
          if (targetLift.position.defaultValue == '')
            this.setTemplateError(
              'Serie',
              'TargetLift in serie must have a defined type',
            );

          for (let profile of targetLift.position.profileValues) {
            if (profile.id == '')
              this.setTemplateError(
                'Serie',
                'The profile in TargetLift has not been defined',
              );
          }
        }

        //Make targetDefinitionsList contain objects instead of primitive values. Or empty if nothing is defined
        for (
          let l = 0;
          l < templateStorage.series[k].targetScoringDefinition.length;
          l++
        ) {
          if (templateStorage.series[k].targetScoringDefinition[l].id == null)
            templateStorage.series[k].targetScoringDefinition[l] = {
              id: templateStorage.series[k].targetScoringDefinition[l],
            };

          if (
            templateStorage.series[k].targetScoringDefinition[l].id.length == 0
          )
            templateStorage.series[k].targetScoringDefinition = [];
        }

        // Remove "approval" if there are no valid hit zones
        if (templateStorage.series[k]?.approval?.criteria) {
          const hasValidHitZones = templateStorage.series[
            k
          ].approval.criteria.some(
            (criteria) => criteria.validZones.length > 0,
          );

          if (!hasValidHitZones) delete templateStorage.series[k].approval;
        }

        // Set scoring convert to null if it is an empty array
        if (templateStorage.series[k]?.targetScoringDefinition) {
          const hasScoringConvert =
            templateStorage.series[k]?.targetScoringDefinition[0]
              ?.scoringConvert?.length > 0 ?? false;

          if (
            !hasScoringConvert &&
            templateStorage.series[k].targetScoringDefinition.length > 0
          ) {
            templateStorage.series[
              k
            ].targetScoringDefinition[0].scoringConvert = null;
          }
        }

        //Validate specified shots for eventtemplates
        templateStorage.series[k].eventTemplates.forEach((eventTemplate) => {
          if (eventTemplate.series.shots != null) {
            const from = eventTemplate.series.shots.from;
            const to = eventTemplate.series.shots.to;
            if (
              from === '' ||
              to === '' ||
              from == null ||
              to == null ||
              from <= 0 ||
              to <= 0
            ) {
              this.setTemplateError(
                'Serie',
                'Specified shots on series event templates is missing or is a negative number',
              );
              return;
            }
          }
        });

        //Stop save if input errors has been found.
        if (this.error) {
          this.isLoading = false;
          return false;
        }
      }

      //Makes sure that eventemplates contains objects
      for (
        let y = 0;
        y < templateStorage.selectionEntry.eventTemplates.length;
        y++
      ) {
        for (
          let a = 0;
          a < templateStorage.selectionEntry.eventTemplates[y].series.length;
          a++
        ) {
          if (
            templateStorage.selectionEntry.eventTemplates[y].series[a].id ==
            null
          ) {
            templateStorage.selectionEntry.eventTemplates[y].series[a] = {
              id: templateStorage.selectionEntry.eventTemplates[y].series[a],
            };
          }
        }
      }

      for (let g = 0; g < templateStorage.series.length; g++) {
        for (
          let h = 0;
          h < templateStorage.series[g].eventTemplates.length;
          h++
        ) {
          if (templateStorage.series[g].eventTemplates[h].series.id == null) {
            templateStorage.series[g].eventTemplates[h].series = {
              id: templateStorage.series[g].eventTemplates[h].series,
            };
          }
        }
      }

      //Makes sure that Taggroups contains objects
      for (let z = 0; z < templateStorage.tagGroups.length; z++) {
        for (let x = 0; x < templateStorage.tagGroups[z].tags.length; x++) {
          if (templateStorage.tagGroups[z].tags[x].id == null) {
            templateStorage.tagGroups[z].tags[x] = {
              id: templateStorage.tagGroups[z].tags[x],
            };
          }
        }
      }

      if (!templateStorage.requiredTargetCount)
        delete templateStorage.requiredTargetCount;

      if (!templateStorage.enableTeamShooting)
        delete templateStorage.nominalNumberOfTeamMembers;

      if (this.mediaCollectionId) {
        if (templateStorage.calloutConfig === null) {
          templateStorage.calloutConfig = {
            audioCollectionId: null,
            defaultAudioProfileId: null,
            mediaCollectionId: null,
            defaultMediaProfileId: null,
            manualStopMediaTemplateId: null,
          };
        }

        if (this.selectedAudioCollection && this.selectedAudioCollection.id) {
          templateStorage.calloutConfig.audioCollectionId =
            this.selectedAudioCollection.id;

          if (this.selectedAudioProfile !== null) {
            templateStorage.calloutConfig.defaultAudioProfileId =
              this.selectedAudioProfile.id;
          } else {
            const audioProfiles =
              this.selectedAudioCollection.jsonData.audioCollection
                .audioProfiles;
            templateStorage.calloutConfig.defaultAudioProfileId =
              audioProfiles.length > 0 ? audioProfiles[0] : null;
          }
        }

        if (this.mediaCollectionId) {
          templateStorage.calloutConfig.mediaCollectionId =
            this.mediaCollectionId;

          templateStorage.calloutConfig.manualStopMediaTemplateId =
            this.selectedManualStopMediaTemplateId;

          if (this.defaultMediaProfileId !== null) {
            templateStorage.calloutConfig.defaultMediaProfileId =
              this.defaultMediaProfileId;
          } else {
            const audioMeidaProfiles =
              this.selectedAudioCollection.jsonData.audioCollection
                .audioProfiles;
            templateStorage.calloutConfig.defaultMediaProfileId =
              audioMeidaProfiles.length > 0 ? audioMeidaProfiles[0] : null;
          }
        }
      } else {
        templateStorage.calloutConfig = null;
      }

      if (templateStorage.executionMode == null) {
        templateStorage.executionMode = 'NORMAL';
      } else
        templateStorage.executionMode =
          templateStorage.executionMode.toUpperCase();

      //Remove generated release variable
      delete templateStorage.released;

      await this.$apollo
        .mutate({
          mutation: ADD_OR_UPDATE_SHOOTING_PROGRAM_TEMPLATE,
          variables: {
            shootingProgramTemplate: templateStorage,
          },
        })
        .then(() => {
          this.isLoading = false;
          this.isSaved = true;
          document.getElementById('buttonSave').style.backgroundColor =
            '#4BB543';
          document.getElementById('buttonSave').style.color = 'white';

          //
          return true;
        })
        .catch(() => {
          this.isSaved = false;
          this.isLoading = false;
          this.setTemplateError(
            'Database',
            'Something went wrong with the database connection. ',
          );
          return false;
        });
    },

    async ExitTemplate() {
      if (!this.isSaved) {
        if (
          await this.$refs.confirmationDialog.open(
            'You have unsaved changes. Would you like to save before you exit?',
          )
        ) {
          //Check if the data is accepted
          await this.saveShootingTemplate();
          if (this.isSaved) {
            this.$router.push({ path: '/shootingprogramtemplates' });
          } else return; //user Input has not been accepted
        }
      }
      this.shootingProgramTemplate = {};
      this.$router.push({ path: '/shootingprogramtemplates' });
    },

    //Activate error when fields are not valid
    setTemplateError(typeOfError, message) {
      this.error = true;

      // Opening the affected tabs
      switch (typeOfError) {
        case 'Time':
          this.tab = 0;
          this.$refs.SeriesPanel[0].setTimeErrorTab();
          break;
        case 'Sum':
          this.tab = 1;
          break;
        case 'Serie':
          this.tab = 0;
          break;
        case 'Database':
          //...
          break;
      }

      this.errorList.push(message);
    },

    async populateData() {
      const uuid = this.$route.params.uuid;
      const SPT = await this.$apollo
        .query({
          query: GET_SHOOTING_PROGRAM_TEMPLATE_QUERY,
          variables: {
            id: uuid,
          },
          fetchPolicy: 'no-cache',
        })
        .then((response) => {
          return response.data.getShootingProgramTemplate[0]; // Query returns an array, we take first element since we use specific ID
        })
        .catch((error) => {
          throw error;
        });

      const DEFQUERY = await this.$apollo
        .query({
          query: GET_TARGET_SCORING_DEFINITION_QUERY,
          client: 'targetScoringDefinitionClient',
          variables: {
            id: '',
          },
        })
        .then((response) => {
          return response.data.getTargetScoringDefinition;
        })
        .catch((error) => {
          throw error;
        });

      this.scoringDefinitions = DEFQUERY;

      if (SPT.executionMode != null) {
        let execMode = SPT.executionMode.toLowerCase();
        SPT.executionMode =
          execMode.charAt(0).toUpperCase() + execMode.slice(1);
      }

      SPT.series.forEach((serie) => {
        serie.procedures.forEach((procedure) => {
          procedure.procedureSteps.forEach((procedureStep) => {
            // If the step does not have a time, we assume it is preparation time
            // This is because of a work around where we use preparation time for steps without time, like with callout: "klar om 10 sekunder fra nå"
            if (!procedureStep.time) {
              procedureStep.time = {
                from: {
                  defaultValue: {
                    value: '',
                    languages: [],
                  },
                  profileValues: [],
                },
                mode: 'PREPARATION_TIME',
              };
            }

            //Update media data to adapt to expected frontend
            if (procedureStep.callouts) {
              procedureStep.callouts.forEach((callout) => {
                if (callout.media) {
                  callout.media = callout.media.map((mediaItem) => ({
                    ...mediaItem,
                    mediaData: mediaItem.mediaData ?? { defaultValue: '' },
                    mediaTemplateId: mediaItem.mediaTemplateId ?? {
                      defaultValue: null,
                    },
                  }));
                }
              });
            }
          });
        });
      });

      this.shootingProgramTemplate = SPT;

      this.name = SPT.name.value;
      this.language = helpers.getLanguage(SPT.defaultValues.language); // Fetches full language name from key value

      if (this.shootingProgramTemplate.selectionEntry == null) {
        this.shootingProgramTemplate.selectionEntry = {
          categories: [],
          eventTemplates: [],
        };
      }

      if (this.shootingProgramTemplate.executionGroups == null) {
        this.shootingProgramTemplate.executionGroups = [];
      }

      delete this.shootingProgramTemplate.version;
      this.finishedLoaded = true;

      if (this.shootingProgramTemplate.calloutConfig?.audioCollectionId)
        this.selectedAudioCollection = await this.getSingleAudioCollection();
      else
        this.selectedAudioCollection = {
          id: null,
          jsonData: { audioCollection: { name: 'No collection' } },
        };

      this.selectedAudioProfile = this.audioProfile();
      if (
        !this.mediaCollectionId &&
        this.audioCollectionOptions.length > 0 &&
        SPT.calloutConfig?.mediaCollectionId
      ) {
        const selectedMediaCollection = this.mediaCollectionOptions.find(
          (media) => media.id === SPT.calloutConfig.mediaCollectionId,
        );
        if (selectedMediaCollection) {
          this.mediaCollectionId = selectedMediaCollection.id;

          if (SPT?.calloutConfig?.manualStopMediaTemplateId) {
            const template = this.mediaTemplates.find(
              (template) =>
                template.id === SPT.calloutConfig.manualStopMediaTemplateId,
            );
            if (template) this.selectedManualStopMediaTemplateId = template.id;
          }

          if (SPT.calloutConfig.defaultMediaProfileId)
            this.defaultMediaProfileId =
              selectedMediaCollection.mediaProfiles.find(
                (profile) =>
                  profile.id === SPT.calloutConfig.defaultMediaProfileId,
              ).id;
        }
      }
    },
  },
};
</script>

<style>
.draghandle {
  cursor: move;
}

.sortable-ghost {
  opacity: 0;
  background: #c8ebfb;
}

#buttonSave {
  background-color: #4bb543;
  color: white;
  min-width: 150px;
}

.withoutline.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none;
}
.withoutline.v-text-field > .v-input__control > .v-input__slot:after {
  border-style: none;
}
</style>
